<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MmKish/tc-custom/9783989731783.jpg?1708053342226" alt="This image is the cover for the book Demonologia, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Demonologia, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "Among the multifarious absurdities and chicaneries, which at different epocha of society have clung to, and engaged the attention of man, absorbing, as it were, his more active intelligence, the marvellous and the ridiculous have alternately and conjointly had to contend for pre-eminence; that, whether it were a mountain in the moon or a bottle conjuror; a live lion stuffed with straw or a mermaid; a Cocklane ghost or a living skeleton; a giant or a pigmy; the delusive bait has invariably been swallowed with avidity, and credited with all the solemnity of absolute devotion."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. S. Forsyth
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58b3383e